// extracted by mini-css-extract-plugin
module.exports = {"phonePreviewContainer":"CPASDashboard_phonePreviewContainer__2UaiF","phonePreview":"CPASDashboard_phonePreview__29LVt"};